import * as React from 'react';
import { ControlButton } from '../ControlButton';
import { ZoomIn } from '../Icons';
import * as styles from './styles.css';
import { jsx as _jsx } from "react/jsx-runtime";
export function ZoomInButton(_ref) {
  var onClick = _ref.onClick,
    disabled = _ref.disabled;
  return /*#__PURE__*/_jsx(ControlButton, {
    className: styles['button'],
    onClick: disabled ? undefined : onClick,
    translucent: true,
    children: /*#__PURE__*/_jsx(ZoomIn, {})
  });
}